import React from "react";
import BoxFrame from "../BoxFrame";
import { FrameTitle, FrameContent } from "../style";
import { Wrapper } from "./style";
import { useTranslation } from "react-i18next";

const Access = () => {
  const { t } = useTranslation();

  return (
    <Wrapper>
      <BoxFrame alignImage="left" dataImage="./images/access.svg">
        <FrameTitle>{t("access.title")}</FrameTitle>
        <FrameContent>
          <p>{t("access.desc1")}</p>
          <p>{t("access.desc2")}</p>
          <p>{t("access.desc3")}</p>
        </FrameContent>
      </BoxFrame>
    </Wrapper>
  );
};

export default Access;
